import { createFileRoute } from '@tanstack/react-router'
import {
  GovUKPageContainer,
  GovUKGrid,
  GovUKGridColumn,
  GovUKContentBox,
} from '@/components/govuk'
import { useStealthMode } from '@/contexts/StealthModeContext'
import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'

export const Route = createFileRoute('/')({ component: HomePage })

const compartmentStyle = {
  fontFamily: 'monospace',
  fontSize: '16px',
  lineHeight: '1.8',
  whiteSpace: 'pre-line' as const,
}

function HomePage() {
  const { stealthMode } = useStealthMode()

  if (stealthMode) {
    return <></>
  }

  return (
    <GovUKPageContainer>
      <GovUKGrid>
        <GovUKGridColumn width="two-thirds">
          <GovUKContentBox padding="large">
            <p style={compartmentStyle}>create shared emotional moments</p>
          </GovUKContentBox>

          <GovUKContentBox padding="large">
            <p style={compartmentStyle}>{`Wind it back
To the start
When the flame was in the heart
But the days keep coming strong
And the shadows growing long

Wind it back
To the start
When the rain was off the chart
And the sun it rises still
On our outpost
On the hill`}</p>
          </GovUKContentBox>
        </GovUKGridColumn>
      </GovUKGrid>
    </GovUKPageContainer>
  )
}
